module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "htpasswd"
    },
    slot: "htpasswd"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userName),
      expression: "model.userName"
    }],
    staticClass: "layui-input",
    attrs: {
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.model.userName)
    },
    on: {
      "keyup": _vm.genHtpasswd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "userName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.userPwd),
      expression: "model.userPwd"
    }],
    staticClass: "layui-input",
    attrs: {
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.model.userPwd)
    },
    on: {
      "keyup": _vm.genHtpasswd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "userPwd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-radio', {
    attrs: {
      "options": _vm.htpasswdOptions,
      "optionsVal": _vm.htpasswdOptions.map(function (s) { return s.Value; })
    },
    model: {
      value: (_vm.currentHtpasswdType),
      callback: function($$v) {
        _vm.currentHtpasswdType = $$v
      },
      expression: "currentHtpasswdType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.afterTxt),
      expression: "model.afterTxt"
    }],
    staticClass: "layui-textarea ",
    attrs: {
      "rows": "3",
      "placeholder": "生成结果..."
    },
    domProps: {
      "value": (_vm.model.afterTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "afterTxt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_vm._v("\n        参考：http://tool.oschina.net/htpasswd\n        "), _c('h4', [_vm._v("什么是 htpasswd ?")]), _vm._v(" "), _c('p', [_vm._v("htpasswd 是开源 http 服务器 "), _c('a', {
    attrs: {
      "href": "http://www.oschina.net/p/apache+http+server",
      "target": "_blank"
    }
  }, [_vm._v("apache httpd")]), _vm._v("\n          的一个命令工具，用于生成 http 基本认证的密码文件。")]), _vm._v(" "), _c('h4', [_vm._v("加密方式有什么区别？")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("MD5:")]), _vm._v("使用MD5加密密码。在Windows, Netware 和TPF上，这是默认的加密方式。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("crypt:")]), _vm._v("使用crypt()加密密码。在除了Windows, Netware和TPF的平台上，这是默认的。 虽然它在所有平台上可以为htpasswd所支持， 但是在Windows,\n          Netware和TPF上不能为httpd服务器所支持。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("SHA:")]), _vm._v("使用SHA加密密码。 它是为了方便转入或移植到使用LDAP Directory Interchange Format (ldif)的Netscape而设计的。")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("plain:")]), _vm._v("不加密，使用纯文本的密码。虽然在所有平台上 htpasswd 都可以建立这样的密码， 但是httpd后台只在Windows, Netware和TPF上支持纯文本的密码。\n        ")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "sitepwd"
    },
    slot: "sitepwd"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.domainName),
      expression: "model.domainName"
    }],
    staticClass: "layui-input",
    attrs: {
      "placeholder": "网站根域名"
    },
    domProps: {
      "value": (_vm.model.domainName)
    },
    on: {
      "keyup": _vm.genSitePwd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "domainName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.domainKey),
      expression: "model.domainKey"
    }],
    staticClass: "layui-input",
    attrs: {
      "placeholder": "网站用户名/Key"
    },
    domProps: {
      "value": (_vm.model.domainKey)
    },
    on: {
      "keyup": _vm.genSitePwd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "domainKey", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('v-button', {
    attrs: {
      "icon": "down"
    },
    on: {
      "click": _vm.genSitePwd
    }
  }, [_vm._v("生成密码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.genPwdResult),
      expression: "model.genPwdResult"
    }],
    staticClass: "layui-textarea ",
    attrs: {
      "rows": "3",
      "placeholder": "生成密码..."
    },
    domProps: {
      "value": (_vm.model.genPwdResult)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "genPwdResult", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n      浏览器访问地址："), _c('a', {
    attrs: {
      "href": "https://metools.js.org/#/genpwd",
      "target": "_blank"
    }
  }, [_vm._v("https://metools.js.org/#/genpwd")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a63daa8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/genpwd.vue
// module id = 606
// module chunks = 2